import request from "@/utils/request";
import ds, { dsc, ___ } from '../utils/daoService/DaoServiceClientES6Adapter'

const ebFtPlanCtnCargo = ds.QEbFtPlanCtnCargo.using(dsc)
const ebBlPlanCtn = ds.QEbBlPlanCtn.using(dsc)

/*
*舱单箱信息汇总
*/
export function manifestSummaryByBox(searchData) {
  return request({
    url: '/web/manifest/manifestSummaryByBox',
    method: 'post',
    data: searchData
  })
}

/*
*舱单提单信息汇总
*/
export function manifestSummaryByTicket(searchData) {
  return request({
    url: '/web/manifest/manifestSummaryByTicket',
    method: 'post',
    data: searchData
  })
}


/*
*舱单箱信息汇总(取json信息)
*/
export function manifestJsonSummaryByBox(searchData) {
  return request({
    url: '/web/manifest/manifestJsonSummaryByBox',
    method: 'post',
    data: searchData
  })
}

/*
*舱单提单信息汇总(取json信息)
*/
export function manifestJsonSummaryByTicket(searchData) {
  return request({
    url: '/web/manifest/manifestJsonSummaryByTicket',
    method: 'post',
    data: searchData
  })
}




//舱单管理查询
export function getManifestManage(data) {
  return request({
    url: '/web/billEdit/getManifestManage',
    method: 'post',
    data
  });
}

export function queryEditManifest(searchData) {
  return request({
    url: '/web/manifest/toEditManifest',
    method: 'post',
    data: searchData
  })
}

export function queryManifestByNos(searchData) {
  return request({
    url: '/web/orderEdit/queryManifestByNos',
    method: 'post',
    data: searchData
  })
}

export function selectEbOrderManifest(searchData) {
  return request({
    url: '/web/orderEdit/selectEbOrderManifest',
    method: 'post',
    data: searchData
  })
}

export function queryAllEbftPlan(searchData) {
  return request({
    url: '/web/manifest/queryAllEbftPlan',
    method: 'post',
    data: searchData
  })
}

export function selectManifest(searchData) {
  return request({
    url: '/web/orderEdit/selectManifest',
    method: 'post',
    data: searchData
  })
}

export function queryMoreEbFtPlan(searchData) {
  return request({
    url: '/web/manifest/queryMoreEbFtPlan',
    method: 'post',
    data: searchData
  })
}

export function queryMoreEbOrderForManifest(searchData) {
  return request({
    url: '/web/manifest/queryMoreEbOrderForManifest',
    method: 'post',
    data: searchData
  })
}

export function updateEbFtPlanIsDeletedStatus(searchData) {
  //searchData为ebBlPlanId的集合
  return request({
    url: '/web/manifest/batchUpdateEbFtPlanIsDeletedStatus',
    method: 'post',
    data: searchData
  })
}

export function selectMakeManifest(searchData) {
  return request({
    url: `/web/orderEdit/selectMakeManifest`,
    method: 'post',
    data: searchData
  })
}

export function addManifest(editDate) {
  return request({
    url: '/web/manifest/addManifest',
    method: 'post',
    data: editDate
  })
}

export function updateManifest(editDate) {
  return request({
    url: '/web/manifest/updateManifest',
    method: 'post',
    data: editDate
  })
}

export function submitManifest(editDate) {
  return request({
    url: '/web/manifest/submitManifest',
    method: 'post',
    data: editDate
  })
}

export function deteleEbFtPlanCtnCargoById(ebFtPlanCtnCargoIds) {
  return ebFtPlanCtnCargo
    .tag('ebFtPlanCtnCargoDetele')
    .deleteById(ebFtPlanCtnCargoIds)
}

export function deteleEbBlPlanCtnById(ebBlPlanCtnIds) {
  return ebBlPlanCtn
    .tag('ebBlPlanCtnDetele')
    .deleteById(ebBlPlanCtnIds)
}

export function queryEbCtnRelation(ebCtnIds) {
  console.log(ebCtnIds)
  return request({
    url: '/web/manifest/queryEbCtnRelation',
    method: 'post',
    data: ebCtnIds
  })
}

export function delectEbCtnById(ebCtnIds) {
  return request({
    url: '/web/manifest/delectEbCtnById',
    method: 'post',
    data: ebCtnIds
  })
}

export function batchSubmitEbFtPlan(tableData) {
  return request({
    url: '/web/manifest/batchSubmitEbFtPlan',
    method: 'post',
    data: tableData
  })
}



export function manifestImport(data) {
  let param = new FormData()
  param.append('file', data, data.name)
  return request({
    url: '/web/manifest/manifestImport',
    method: 'post',
    data: param,
    headers: {
    'Content-Type': 'multipart/form-data'
  }
  })
}


export function delectGoCtnById(searchData) {
  return request({
    url: '/web/manifest/delectGoCtnById',
    method: 'post',
    data: searchData
  })
}

export function queryMdReportTemplate (data) {
  return request({
    url: `/common/cts-manager/custom-api/CTS_ILP_MdReportTemplate/common/CTS_ILP_MdReportTemplate`,
    method: 'post',
    data
  });
}
